import settings from '@/settings'

let list = (headers) => {
  return fetch(`${settings.apetrusApi}/formaspagamento/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers,
    cache: 'default'
  })
}
export default {
  list
}
